import Api_Mec from "./Api_Mec";

class MEC_Plantillas_compartidas_api extends Api_Mec {
  constructor() {
    super();
  }

  async compartirPlantilla(
    id_plantilla,
    funcionario_remitente,
    correo_usuario1,
    correo_usuario2,
    correo_usuario3
  ) {
    let response;

    try {
      response = await this.post(
        `${this.url_api}/MEC_API/MEC_Plantillas_compartidas/compartir_plantilla`,
        {
          id_plantilla,
          funcionario_remitente,
          correo_usuario1,
          correo_usuario2,
          correo_usuario3,
        },
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }

  async aceptarRechazarPlantilla(id_Plantillas_compartidas, accion) {
    let response;

    try {
      response = await this.post(
        `${this.url_api}/MEC_API/MEC_Plantillas_compartidas/aceptar_cancelar_plantilla`,
        {
          id_Plantillas_compartidas,
          accion,
        },
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }
}

export default MEC_Plantillas_compartidas_api;
